import i18n from "../i18n";
import { toast } from "react-toastify";

export const notifier = {
  success: (text, onClose, autoClose) => toast.success(i18n.t(text), { onClose, autoClose }),
  error: (text, onClose, autoClose) => toast.error(i18n.t(text), { onClose, autoClose }),
  info: (text, onClose, autoClose) => toast.info(i18n.t(text), { onClose, autoClose }),
  warning: (text, onClose, autoClose) => toast.warning(i18n.t(text), { onClose, autoClose })
};

export const errorsHandler = (errors) => {
  const errorObject = {};
  switch (typeof errors) {
    case "string":
      errorObject.error = [errors];
      break;
    case "object":
      if (Array.isArray(errors)) {
        errors.forEach((error) => {
          errorObject[error.field] = [error.message];
        }
        );
      } else {
        Object.entries(errors).forEach(([key, value]) => {
          errorObject[key] = [];
          if (typeof value === "string") {
            errorObject[key].push(value);
          } else if (Array.isArray(value)) {
            value.forEach((error) => {
              if (typeof error === "string") {
                errorObject[key].push(error);
              } else if (Array.isArray(error)) {
                errorObject[key] = [...errorObject[key], ...error];
              } else {
                Object.entries(error).forEach(([key2, value2]) => {
                  const nestedErrors = errorsHandler(value2);
                  Object.entries(nestedErrors).forEach(([key3, value3]) => {
                    errorObject[`${key}.${key2}.${key3}`] = value3;
                  });
                  if (!errorObject[`${key}.${key2}`].length) {
                    delete errorObject[`${key}.${key2}`];
                  }
                });
              }
            });
          } else {
            const nestedErrors = errorsHandler(value);
            Object.entries(nestedErrors).forEach(([key2, value2]) => {
              errorObject[`${key}.${key2}`] = value2;
            });
          }
          if (!errorObject[key].length) {
            delete errorObject[key];
          }
        });
      }
      break;
    default:
      break;
  }
  return errorObject;
};

/**
   *  @description: This function is used to notify the user of errors coming from the server
   * @param errors: array of errors or object of errors or string of errors
   * @return: null
   *
   */
export const stringErrorsHandler = (errors) => {
  const errorObject = errorsHandler(errors);
  return Object.entries(errorObject).map(([key, value]) => (`${key}: ${value instanceof Array ? value.join(", ") : value}`)).join("\n");
};

/**
   *  @description: This function is used to notify the user of errors coming from the server
   * @param errors: array of errors or object of errors or string of errors
   * @return: null
   *
   */
export const notifyErrors = (errors) => {
  const errorsObject = errorsHandler(errors);
  Object.entries(errorsObject).forEach(([key, value]) =>
    notifier.error(`${key}: ${value instanceof Array ? value.join(", ") : value}`)
  );
};
